import { useState } from 'react';
import { Grid } from '@mantine/core';
import AgentCards from '../components/AgentsCards';
import Metadata from '../components/Metadata';
import { agentOptions as defaultAgents } from '../constants/GeneratedContent';
import { Page } from '../constants/pageTitles';

const AgentsPage = () => {
  const [agentsOptions, setAgentsOptions] = useState(defaultAgents);

  const selectAgent = (option) => {
    setAgentsOptions((prev) =>
      prev.map((agent, idx) => (idx === option.index ? { ...agent, selected: !agent.selected } : agent))
    );
  };

  return (
    <>
      <Metadata title={Page.agents} />
      <Grid>
        <Grid.Col span={12}>
          <Grid>
            {agentsOptions.map((option, index) => (
              <AgentCards key={index} index={index} option={option} select={selectAgent} />
            ))}
          </Grid>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default AgentsPage;
